import AICaptionsUpsellModal from './AICaptionsUpsellModal';

export default AICaptionsUpsellModal;
